/**
 * Tamaño de página y márgenes unificados para todas las exportaciones a PDF
 * (planillas, formularios de inscripción, evaluaciones y declaraciones).
 *
 * Replican los márgenes del informe en Word (utils/generarInformeWord.ts), que
 * usa 30 mm a lado y lado, para que todos los documentos que genera la
 * plataforma se vean con el mismo ancho de márgenes.
 */
export const PDF_PW = 210; // ancho A4 en mm
export const PDF_PH = 297; // alto A4 en mm
export const PDF_MG = 30; // margen en mm (todos los lados)
export const PDF_CW = PDF_PW - 2 * PDF_MG; // ancho útil: 150 mm

/** Ancho de la columna de etiquetas en los formularios (≈40% del ancho útil). */
export const PDF_LABEL_W = 58;
